import styled from 'styled-components';

export const SavingContent = styled.div`
  display: contents;
`;

export const SavingAnnouncement = styled.span`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
